import { render, staticRenderFns } from "./ProponerDialog.vue?vue&type=template&id=3b7ead10&scoped=true"
import script from "./ProponerDialog.vue?vue&type=script&lang=js"
export * from "./ProponerDialog.vue?vue&type=script&lang=js"
import style0 from "./ProponerDialog.vue?vue&type=style&index=0&id=3b7ead10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7ead10",
  null
  
)

export default component.exports